import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import useTranslate from '../../../core/languages/hooks/useTranslate';
import {getTransportReferenceLabel} from "../../utils/transportLabels";
import {TransportEnum} from "../../enums/TransferTransportEnum";
import InputField from "../../../ui/components/InputField/InputField";

const ArrivalTransportCompanyAndNumber: React.FC = () => {
    const t = useTranslate();
    const { control, watch, formState: { errors } } = useFormContext();
    const arrivalTransport = watch("arrivalTransport");

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Controller// 👈 fuerza re-render con nuevas rules
                name="arrivalTransportReference"
                control={control}
                rules={{
                    required: arrivalTransport !== TransportEnum.OTHER && arrivalTransport
                        ? t('common.feedback.field_required')
                        : false
                }}
                render={({ field }) => (
                    <InputField
                        {...field}
                        label={getTransportReferenceLabel(t, arrivalTransport, 'reference')}
                        type="text"
                        disabled={arrivalTransport === TransportEnum.OTHER || !arrivalTransport}
                        error={errors.arrivalTransportReference?.message}
                    />
                )}
            />
            <Controller
                name="arrivalTransportReferenceNumber"
                control={control}
                rules={{
                    required: arrivalTransport !== TransportEnum.OTHER && arrivalTransport ? t('common.feedback.field_required') : false
                }}
                render={({ field }) => (
                    <InputField
                        {...field}
                        label={getTransportReferenceLabel(t, arrivalTransport, 'number')}
                        type="text"
                        disabled={arrivalTransport === TransportEnum.OTHER || !arrivalTransport}
                        error={errors.arrivalTransportReferenceNumber?.message}
                    />
                )}
            />
        </div>

    );
};

export default ArrivalTransportCompanyAndNumber;

